<template>
  <div>
    <div class="d-flex align-center">
      <ImageMedia
        class="team-member__avatar"
        :size="IMAGE_SIZES.SQUARE"
        :src="avatarMediaObject"
        :defaultImage="defaultImage"
      />

      <p
        v-if="name || lastName"
        class="mb-0 team-member__info"
        data-testid="teamMember-text-name"
      >
        {{ name }} <br />
        {{ lastName }}
      </p>

      <p v-else class="mb-0 team-member__info">{{ email }}</p>
    </div>
  </div>
</template>

<script>
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import defaultImage from '@/assets/images/user.svg'
import { IMAGE_SIZES } from 'rever-media-sdk'

export default {
  name: 'TeamMember',

  data() {
    return {
      defaultImage,
      IMAGE_SIZES,
    }
  },

  components: {
    ImageMedia,
  },

  props: {
    avatarMediaObject: {
      type: Object,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: false,
    },
    email: {
      type: String,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen, print {
  .team-member__avatar {
    border-radius: 50%;
    height: 30px;
    margin-right: 10px;
    object-fit: cover;
    width: 30px;
  }

  .team-member__info {
    color: $color-blue-grey-darken3;
    font-size: 11px;
    max-width: 70%;
    max-height: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
